module.exports = __webpack_public_path__ + "img/bloco-de-anotacoes.acff566b.svg";